let ctx = null;
let master = null;
let started = false;
let muted = typeof localStorage !== "undefined" && localStorage.getItem("fenrion-muted") === "1";

export const isMuted = () => muted;

export function setMuted(m) {
  muted = m;
  localStorage.setItem("fenrion-muted", m ? "1" : "0");
  if (master && ctx) {
    master.gain.linearRampToValueAtTime(m ? 0 : 1, ctx.currentTime + 0.2);
  }
}

function ensureCtx() {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = muted ? 0 : 1;
    master.connect(ctx.destination);
  }
  if (ctx.state === "suspended") ctx.resume();
}

export function startAmbient() {
  if (started) return;
  started = true;
  ensureCtx();

  const ambGain = ctx.createGain();
  ambGain.gain.value = 0;
  ambGain.connect(master);
  ambGain.gain.linearRampToValueAtTime(0.045, ctx.currentTime + 3.5);

  const voices = [
    { freq: 55, type: "sine", vol: 0.5 },
    { freq: 82.41, type: "sine", vol: 0.28 },
    { freq: 110, type: "triangle", vol: 0.16 },
    { freq: 164.81, type: "sine", vol: 0.08 },
  ];
  voices.forEach(({ freq, type, vol }) => {
    const osc = ctx.createOscillator();
    osc.type = type;
    osc.frequency.value = freq;
    const g = ctx.createGain();
    g.gain.value = vol;
    osc.connect(g);
    g.connect(ambGain);
    osc.start();
  });

  const lfo = ctx.createOscillator();
  lfo.frequency.value = 0.07;
  const lfoGain = ctx.createGain();
  lfoGain.gain.value = 0.018;
  lfo.connect(lfoGain);
  lfoGain.connect(ambGain.gain);
  lfo.start();
}

export function blip(freq = 520, dur = 0.09, vol = 0.1) {
  if (muted || !started || !ctx) return;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, ctx.currentTime);
  osc.frequency.exponentialRampToValueAtTime(freq * 0.7, ctx.currentTime + dur);
  g.gain.setValueAtTime(vol, ctx.currentTime);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
  osc.connect(g);
  g.connect(master);
  osc.start();
  osc.stop(ctx.currentTime + dur);
}
